<template>
  <div>
    <Head title="Universitas" />
    <h1 class="mb-8 text-2xl font-bold">Universitas</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block mt-4 text-gray-700">Aktif:</label>
        <select v-model="form.is_active" class="w-full mt-1 form-select">
          <option :value="null" />
          <option value="1">Aktif</option>
          <option value="0">Tidak Aktif</option>
        </select>
        <label class="block mt-4 text-gray-700">Status:</label>
        <select v-model="form.status" class="w-full mt-1 form-select">
          <option :value="null" />
          <option value="PTN">PTN</option>
          <option value="PTKL">PTKL</option>
          <option value="PTNL">PTN Lokal</option>
          <option value="PTS">PTS</option>
        </select>
      </search-filter>
      <Link v-if="can('write universitas')" class="btn-indigo" href="/universities/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        <span class="hidden md:inline">&nbsp;Universitas</span>
      </Link>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Nama</th>
            <th class="px-6 pt-6 pb-4">Kode PT</th>
            <th class="px-6 pt-6 pb-4">Alamat Website</th>
            <th class="px-6 pt-6 pb-4">Jumlah Prodi</th>
            <th class="px-6 pt-6 pb-4">Status</th>
            <th class="px-6 pt-6 pb-4">Active</th>
            <th v-if="can('write universitas')" class="px-6 pt-6 pb-4 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="university in universities.data" :key="university.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-4 border-t">
              {{ university.nama }}
            </td>
            <td class="p-4 border-t">
              {{ university.kode_pt || '-' }}
            </td>
            <td class="p-4 border-t">
              <a class="text-indigo-500" target="blank" :href="university.url">
                {{ university.url }}
              </a>
            </td>
            <td class="w-6 p-4 text-center border-t">
              <Link :href="`/universities/${university.id}/prodis`" class="text-indigo-400" title="Data Prodi">
                <u>{{ university.jumlah_prodi }}</u>
              </Link>
            </td>
            <td class="p-4 border-t">
              {{ university.status }}
            </td>
            <td class="p-4 border-t">
              {{ university.is_active }}
            </td>
            <td v-if="can('write universitas')" class="w-px p-4 border-t">
              <Link class="rounded-l btn-indigo-sm" :href="`/universities/${university.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="rounded-r btn-red-sm" @click.prevent="destroy(university.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="universities.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write universitas') ? 7 : 6">Tidak ada data universitas.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="universities.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    universities: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        status: this.filters.status,
        is_active: this.filters.is_active,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/universities', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/universities/${id}`)
        }
      })
    },
  },
}
</script>
